// Import model
import { FilterBomKitRequest } from '../models/FilterBomKitRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { BomKitCondition } from '../models/BomKitCondition';
import { BomKitFields } from '../models/BomKitFields';
import { BomKitIndexedFields } from '../models/BomKitIndexedFields';

// Import dependency serializers (for complex types)
import { BomKitConditionSerializer } from './BomKitConditionSerializer';
import { BomKitFieldsSerializer } from './BomKitFieldsSerializer';
import { BomKitIndexedFieldsSerializer } from './BomKitIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterBomKitRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterBomKitRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterBomKitRequest instance
   */
  static deserialize(json: string): FilterBomKitRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterBomKitRequest instance
   */
  static fromObject(obj: any): FilterBomKitRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterBomKitRequest');
    }


    const instance: FilterBomKitRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as BomKitIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as BomKitFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        BomKitConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterBomKitRequest instances
   */
  static deserializeArray(json: string): FilterBomKitRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterBomKitRequest instance to a JSON string
   */
  static serialize(instance: FilterBomKitRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterBomKitRequest instance to a plain object
   */
  static toObject(instance: FilterBomKitRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        BomKitConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterBomKitRequest instances to a JSON string
   */
  static serializeArray(instances: FilterBomKitRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
